import Alabama from "./SVG/Alabama"
import Alaska from "./SVG/Alaska"
import Arizona from "./SVG/Arizona"
import Arkansas from "./SVG/Arkansas"
import California from "./SVG/California"
import Colorado from "./SVG/Colorado"
import Connecticut from "./SVG/Connecticut"
import Corporate from "./SVG/Corporate"
import Delaware from "./SVG/Delaware"
import Florida from "./SVG/Florida"
import Georgia from "./SVG/Georgia"
import Hawaii from "./SVG/Hawaii"
import Idaho from "./SVG/Idaho"
import Illinois from "./SVG/Illinois"
import Indiana from "./SVG/Indiana"
import Iowa from "./SVG/Iowa"
import Kansas from "./SVG/Kansas"
import Kentucky from "./SVG/Kentucky"
import Louisiana from "./SVG/Louisiana"
import Maine from "./SVG/Maine"
import Maryland from "./SVG/Maryland"
import Massachusetts from "./SVG/Massachusetts"
import Michigan from "./SVG/Michigan"
import Minnesota from "./SVG/Minnesota"
import Mississippi from "./SVG/Mississippi"
import Missouri from "./SVG/Missouri"
import Montana from "./SVG/Montana"
import Nebraska from "./SVG/Nebraska"
import Nevada from "./SVG/Nevada"
import NewHampshire from "./SVG/NewHampshire"
import NewJersey from "./SVG/NewJersey"
import NewMexico from "./SVG/NewMexico"
import NewYork from "./SVG/NewYork"
import NortCarolina from "./SVG/NorthCarolina"
import NorthDakota from "./SVG/NorthDakota"
import Ohio from "./SVG/Ohio"
import Oklahoma from "./SVG/Oklahoma"
import Oregon from "./SVG/Oregon"
import Pennsylvania from "./SVG/Pennsylvania"
import RhodeIsland from "./SVG/RhodeIsland"
import SouthCarolina from "./SVG/SouthCarolina"
import SouthDakota from "./SVG/SouthDakota"
import Tennessee from "./SVG/Tennessee"
import Texas from "./SVG/Texas"
import Utah from "./SVG/Utah"
import Vermont from "./SVG/Vermont"
import Virginia from "./SVG/Virginia"
import Washington from "./SVG/Washington"
import WestVirginia from "./SVG/WestVirginia"
import Wisconsin from "./SVG/Wisconsin"
import Wyoming from "./SVG/Wyoming"

const states =
  [
    {
      StateID: 1,
      StateCode: "AL",
      StateName: "Alabama",
      icon: Alabama
    },
    {
      StateID: 2,
      StateCode: "AK",
      StateName: "Alaska",
      icon: Alaska
    },
    {
      StateID: 3,
      StateCode: "AZ",
      StateName: "Arizona",
      icon: Arizona
    },
    {
      StateID: 4,
      StateCode: "AR",
      StateName: "Arkansas",
      icon: Arkansas
    },
    {
      StateID: 5,
      StateCode: "CA",
      StateName: "California",
      icon: California
    },
    {
      StateID: 6,
      StateCode: "CO",
      StateName: "Colorado",
      icon: Colorado
    },
    {
      StateID: 7,
      StateCode: "CT",
      StateName: "Connecticut",
      icon: Connecticut
    },
    {
      StateID: 8,
      StateCode: "DE",
      StateName: "Delaware",
      icon: Delaware
    },
    {
      StateID: 10,
      StateCode: "FL",
      StateName: "Florida",
      icon: Florida
    },
    {
      StateID: 11,
      StateCode: "GA",
      StateName: "Georgia",
      icon: Georgia
    },
    {
      StateID: 12,
      StateCode: "HI",
      StateName: "Hawaii",
      icon: Hawaii
    },
    {
      StateID: 13,
      StateCode: "ID",
      StateName: "Idaho",
      icon: Idaho
    },
    {
      StateID: 14,
      StateCode: "IL",
      StateName: "Illinois",
      icon: Illinois
    },
    {
      StateID: 15,
      StateCode: "IN",
      StateName: "Indiana",
      icon: Indiana
    },
    {
      StateID: 16,
      StateCode: "IA",
      StateName: "Iowa",
      icon: Iowa
    },
    {
      StateID: 17,
      StateCode: "KS",
      StateName: "Kansas",
      icon: Kansas
    },
    {
      StateID: 18,
      StateCode: "KY",
      StateName: "Kentucky",
      icon: Kentucky
    },
    {
      StateID: 19,
      StateCode: "LA",
      StateName: "Louisiana",
      icon: Louisiana
    },
    {
      StateID: 20,
      StateCode: "ME",
      StateName: "Maine",
      icon: Maine
    },
    {
      StateID: 21,
      StateCode: "MD",
      StateName: "Maryland",
      icon: Maryland
    },
    {
      StateID: 22,
      StateCode: "MA",
      StateName: "Massachusetts",
      icon: Massachusetts
    },
    {
      StateID: 23,
      StateCode: "MI",
      StateName: "Michigan",
      icon: Michigan
    },
    {
      StateID: 24,
      StateCode: "MN",
      StateName: "Minnesota",
      icon: Minnesota
    },
    {
      StateID: 25,
      StateCode: "MS",
      StateName: "Mississippi",
      icon: Mississippi
    },
    {
      StateID: 26,
      StateCode: "MO",
      StateName: "Missouri",
      icon: Missouri
    },
    {
      StateID: 27,
      StateCode: "MT",
      StateName: "Montana",
      icon: Montana
    },
    {
      StateID: 28,
      StateCode: "NE",
      StateName: "Nebraska",
      icon: Nebraska
    },
    {
      StateID: 29,
      StateCode: "NV",
      StateName: "Nevada",
      icon: Nevada
    },
    {
      StateID: 30,
      StateCode: "NH",
      StateName: "New Hampshire",
      icon: NewHampshire
    },
    {
      StateID: 31,
      StateCode: "NJ",
      StateName: "New Jersey",
      icon: NewJersey
    },
    {
      StateID: 32,
      StateCode: "NM",
      StateName: "New Mexico",
      icon: NewMexico
    },
    {
      StateID: 33,
      StateCode: "NY",
      StateName: "New York",
      icon: NewYork
    },
    {
      StateID: 34,
      StateCode: "NC",
      StateName: "North Carolina",
      icon: NortCarolina
    },
    {
      StateID: 35,
      StateCode: "ND",
      StateName: "North Dakota",
      icon: NorthDakota
    },
    {
      StateID: 36,
      StateCode: "OH",
      StateName: "Ohio",
      icon: Ohio
    },
    {
      StateID: 37,
      StateCode: "OK",
      StateName: "Oklahoma",
      icon: Oklahoma
    },
    {
      StateID: 38,
      StateCode: "OR",
      StateName: "Oregon",
      icon: Oregon
    },
    {
      StateID: 39,
      StateCode: "PA",
      StateName: "Pennsylvania",
      icon: Pennsylvania
    },
    {
      StateID: 40,
      StateCode: "RI",
      StateName: "Rhode Island",
      icon: RhodeIsland
    },
    {
      StateID: 41,
      StateCode: "SC",
      StateName: "South Carolina",
      icon: SouthCarolina
    },
    {
      StateID: 42,
      StateCode: "SD",
      StateName: "South Dakota",
      icon: SouthDakota
    },
    {
      StateID: 43,
      StateCode: "TN",
      StateName: "Tennessee",
      icon: Tennessee
    },
    {
      StateID: 44,
      StateCode: "TX",
      StateName: "Texas",
      icon: Texas
    },
    {
      StateID: 45,
      StateCode: "UT",
      StateName: "Utah",
      icon: Utah
    },
    {
      StateID: 46,
      StateCode: "VT",
      StateName: "Vermont",
      icon: Vermont
    },
    {
      StateID: 47,
      StateCode: "VA",
      StateName: "Virginia",
      icon: Virginia
    },
    {
      StateID: 48,
      StateCode: "WA",
      StateName: "Washington",
      icon: Washington
    },
    {
      StateID: 49,
      StateCode: "WV",
      StateName: "West Virginia",
      icon: WestVirginia
    },
    {
      StateID: 50,
      StateCode: "WI",
      StateName: "Wisconsin",
      icon: Wisconsin
    },
    {
      StateID: 51,
      StateCode: "WY",
      StateName: "Wyoming",
      icon: Wyoming
    },
    {
      StateID: 52,
      StateCode: "Corp",
      StateName: "Corporate",
      icon: Corporate
    }
  ]

export default states